import { Box, Divider, Typography } from "@mui/material";
import { useTemplate } from "containers/templateDetail/store";
import * as React from "react";
import Customizer from "./customizer";
import Favorite from "./favorite";
import Options from "./options";
import PriceCalculate from "./priceCalculate";
import ReviewScore from "./reviewScore";

export default function ProductDetail(): React.ReactElement {
  const template = useTemplate();

  return (
    <div>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <Typography variant="h5" component="h1">
          {template.title}
        </Typography>
      </Box>
      <ReviewScore />
      <Divider sx={{ my: 3 }} />
      <Options />
      <PriceCalculate />
      <Box sx={{ mt: 2, display: "flex", alignItem: "center" }}>
        <Box sx={{ flex: 1 }}>
          <Customizer template={template} />
        </Box>
        <Favorite />
      </Box>
    </div>
  );
}
